function checkChecklist()
{
    $('.bundle__section:not(.bundle-checklist)').each(function(){
        var product_id = $(this).data('productid');
        var qty_max = $(this).data('max');
        var relevant_checklist_row = $('.bundle__checklist-item[data-productid="'+product_id+'"]');
        var qty_total = parseInt(0);
        var qty_input = parseInt(0);
        var amount_of_rows = $(this).find('.bundle__content .bundle__options .input-rows .bundle__input-row:not(.to-clone)').length;

        $(this).find('.bundle__input-row:not(.to-clone)').each(function(){
            var qty_input = parseInt($(this).find('.qty-input').val());
            qty_total += parseInt(qty_input);
        })

        if ( qty_total == qty_max ) {
            relevant_checklist_row.find('.amount').addClass('complete');
        } else {
            relevant_checklist_row.find('.amount').removeClass('complete');
        }

        //can they remove the row?
        if ( qty_total-1 <= 0 ) {
            $(this).find('.bundle__input-row .delete').addClass('disabled');
        } else {
            $(this).find('.bundle__input-row .delete').removeClass('disabled');
        }

        //can they add a row?
        if ( qty_total >= qty_max ) {
            $(this).find('.bundle__input-row .add').addClass('disabled');
        } else {
            $(this).find('.bundle__input-row .add').removeClass('disabled');
        }
        
        relevant_checklist_row.find('.amount span').text(qty_total);
        $(this).find('.bundle__product-title .amount-left span').text(qty_total);

    });

    //change add to basket button
    var checked_qty = parseInt(0);
    $('.bundle__checklist-item').each(function(){
        $(this).find('.complete span').each(function(){
            var value = $(this).html();
            checked_qty += parseInt(value);
        })
    })
    var bundle_qty = parseInt(0);
    $('.bundle__section:not(.bundle-checklist)').each(function(){
        var qty_max = $(this).data('max');
        bundle_qty += parseInt(qty_max);
    })
    
    //if the total complated qty is equal to the bundles qty
    if ( checked_qty == bundle_qty ) {
        $('.add-bundle-to-basket').removeClass('disabled');
    } else {
        $('.add-bundle-to-basket').addClass('disabled');
    }
}

//qty-input onchange calculate all the rows qty's 
//change .amount-left span to total QTY
//change checklist relevant row qty - .bundle__checklist-item // add/remove 'complete' class to .amount
$('.qty-input').on('change', function() {
    checkChecklist();
    // var parent_block = $(this).parents('.bundle__section');
    // var product_id   = parent_block.data('productid');
    // var qty_max = parent_block.data('max');
    // var relevant_checklist_row = $('.bundle__checklist-item[data-productid="'+product_id+'"]');
    // var qty_total = parseInt(0);
    // var qty_input = parseInt(0);

    // parent_block.find('.bundle__input-row:not(.to-clone)').each(function(){
    //     var qty_input = parseInt( $(this).find('.qty-input').val() );
    //     qty_total += parseInt(qty_input);
    // });

    // if ( qty_total == qty_max ) {
    //     relevant_checklist_row.find('.amount').addClass('complete');
    //     $('.add-bundle-to-basket').removeClass('disabled');
    // } else {
    //     relevant_checklist_row.find('.amount').removeClass('complete');
    //     $('.add-bundle-to-basket').addClass('disabled');
    // }

    // //change the figures whether theyre within range or not
    // relevant_checklist_row.find('.amount span').text(qty_total);
    // parent_block.find('.bundle__product-title .amount-left span').text(qty_total);
    
});

$('.add:not(.disabled) .add-row').on('click', function(e) {
    e.preventDefault();
    var parent_block = $(this).parents('.bundle__section');
    var parent_id    = parent_block.data('productid');
    var qty_max      = parent_block.data('max');
    var row_clone    = parent_block.find('.bundle__content .bundle__options .input-rows .to-clone'); 
    var qty_total = parseInt(0); //qty input total within inputs
    var qty_input = parseInt(0); //individual input
    var amount_of_rows = parent_block.find('.bundle__content .bundle__options .input-rows .bundle__input-row:not(.to-clone)').length;

    parent_block.find('.bundle__input-row:not(.to-clone)').each(function(){
        var qty_input = parseInt($(this).find('.qty-input').val());
        qty_total += parseInt(qty_input);
    });


    if ( qty_total < qty_max ) {
        row_clone.find('.form__input--select2').each(function() {
            if ( $(this).hasClass("select2-hidden-accessible") ) {
                $(this).select2('destroy'); //destroy select2
            }
        });
        row_clone.clone(true).insertAfter(parent_block.find('.bundle__content .bundle__options .input-rows .bundle__input-row:last'));
        parent_block.find('.bundle__content .bundle__options .input-rows .bundle__input-row:last').find('.qty-input').val();

        parent_block.find('.bundle__content .bundle__options .input-rows .to-clone .form__input--select2').each(function() {
            select2AddClass($(this));
        });
        parent_block.find('.bundle__content .bundle__options .input-rows .bundle__input-row:last .form__input--select2').each(function() {
            select2AddClass($(this));
        });

        parent_block.find('.bundle__content .bundle__options .input-rows .bundle__input-row:last').removeClass('to-clone');

        //get current row ID + 1 for new rows ID
        var new_block = $(this).parents('.bundle__input-row');
        var new_block_id = parseInt(new_block.attr('data-row'));
        new_block_id += parseInt(1);

        parent_block.find('.bundle__content .bundle__options .input-rows .bundle__input-row:last').attr('data-row', new_block_id); //give row new rowid
        parent_block.find('.bundle__content .bundle__options .input-rows .bundle__input-row:last .input.colours select').attr('name', 'products['+parent_id+']['+new_block_id+'][colour]'); //update colour input name
        parent_block.find('.bundle__content .bundle__options .input-rows .bundle__input-row:last .input.sizes select').attr('name', 'products['+parent_id+']['+new_block_id+'][size]'); //update size input name
        parent_block.find('.bundle__content .bundle__options .input-rows .bundle__input-row:last .input.row-quant input[type="number"]').attr('name', 'products['+parent_id+']['+new_block_id+'][qty]'); //input qty input name

        checkChecklist();
    }
});

$('.delete:not(.disabled)').on('click', function(e) {
    e.preventDefault();
    var parent_block = $(this).parents('.bundle__section');
    var parent_row   = $(this).parents('.bundle__input-row');
    var parent_id    = parent_block.data('productid');
    var qty_max      = parent_block.data('max'); 
    var amount_of_rows = parent_block.find('.bundle__content .bundle__options .input-rows .bundle__input-row:not(.to-clone)').length;

    //if amount of rows after removing is more than 0 only
    if ( amount_of_rows-1 > 0) {
        parent_row.remove();
        checkChecklist();
    } 
});

//form__input--select2--colors onchange update product image based on colour?
//also update available sizes to choose
$('.input.colours .form__input--select2--colors').on('select2:select', function (e) {
    var chosenColour = $(this).val();
    var productID = $(this).parents('.bundle__section').data('productid');
    var sectionImage = $(this).parents('.bundle__section').find('.bundle__image .image img');
    var select_to_update = $(this).parents('.bundle__input-row').find('.input.sizes .form__input--select2');
    
    //ajax to change image
    $.ajax({
        type: 'POST',
        url: $(document.body).data('base') + '/ajax/bundles/get-colour-options.php',
        data: {
            colourid: chosenColour,
            productid: productID
        },
        success: function(response) {
            response = JSON.parse(response);
            sectionImage.attr('src', response.image);
            // type: response.status
        },
        error: function() {
            console.log('Ajax request For Image not received');
        }
    });

    var _class  = select_to_update.attr('class');
    var _dclass = select_to_update.attr('dropdown-class');

    _class.replace('select2-hidden-accessible','');
    _dclass.replace('select2-hidden-accessible','');

    //ajax for select
    select_to_update.select2({
        containerCssClass: _class,
        dropdownCssClass: _dclass,
        ajax: {
            url: $(document.body).data('base') + '/ajax/bundles/get-colour-options.php',
            type: 'post',
            dataType: 'json',
            delay: 250,
            data: {
                colourid: chosenColour,
                productid: productID
            },
            processResults: function (data) {
              // Tranforms the top-level key of the response object from 'items' to 'results'
              return {
                results: data.sizes
              };
            }
        }
    })
    select_to_update.trigger("change");

});

function select2AddClass(element) {
    element.each(function(){

        if($(this).hasClass('select2-hidden-accessible')) {
            $(this).removeClass('select2-hidden-accessible');
        }

        var _class  = $(this).attr('class');
        var _dclass = $(this).attr('dropdown-class');

        $(this).select2({
            containerCssClass: _class,
            dropdownCssClass: _dclass,
            minimumResultsForSearch: 10,
        });
    });
}

$(document).ready(function(){
    checkChecklist();

    var $bundle_form = $('form.form__bundle');
    $bundle_form.validate({
        rules: {

        },
        submitHandler: function() {

        if ( !$('.add-bundle-to-basket').hasClass('disabled') ) {
            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/bundles/add-bundle-to-cart.php',
                data: $bundle_form.serialize(),
                success: function(response) {
                    response = JSON.parse(response);

                    swal({
                        title: response.title,
                        text: response.message,
                        type: response.status,
                        confirmButtonColor: "#f15a24"
                      }, function() {
                          if('success' == response.status) {
                            window.location.href = $(document.body).data('base') + '/cart';
                          }
                      })
                },
                  error: function() {
                    console.log('Ajax request not received');
                }
            });
        }

        return false;
      }
    });
    
})